import * as sup from "superstruct";

import { createResourceStruct } from "@/modules/api/utils/jsonApiStructs";
import { groupItemIdentifierStruct } from "@/modules/groups/api/resources/groupsIdentifierStruct";

import { unacknowledgedLevelItemIdentifierStruct } from "./unacknowledgedLevelIdentifierStruct";

const unacknowledgedLevelItemResourceStruct = createResourceStruct({
  identifier: unacknowledgedLevelItemIdentifierStruct,
  attributes: sup.object({
    name: sup.string(),
    order: sup.integer(),
  }),
  relationships: sup.object({
    userGroup: sup.object({
      data: groupItemIdentifierStruct,
    }),
  }),
});

export const unacknowledgedLevelsResourceStruct = sup.array(
  unacknowledgedLevelItemResourceStruct
);
